<template>
  <v-modal
    v-if="showModal || isPresent(currentOverlay)"
    @close="handleClose"
    modal-class="overlay-modal"
  >
    <template :slot="OVERLAY_MODAL_HASH">
      <div class="overlay-modal__content">
        <template v-if="isLoading">
          <div class="d-flex justify-content-center pt-5">
            <v-loader />
          </div>
        </template>
        <template v-else-if="isPresent(currentOverlay)">
          <blocks-container :blocks="currentOverlay.stream.blocks" />
        </template>
      </div>
    </template>
  </v-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex"

import { isPresent } from "@/lib/utils"
import EventBus, { EVENTS } from "@/lib/event-bus"

export const OVERLAY_MODAL_HASH = "#overlay"

export default {
  components: {
    BlocksContainer: () => import("@/components/stream/BlocksContainer")
  },

  data() {
    return {
      currentOverlay: null,
      showModal: false,
      isLoading: false,
      OVERLAY_MODAL_HASH
    }
  },

  mounted() {
    EventBus.$on(EVENTS.TRIGGER_OVERLAY, overlayId => {
      this.$router.push(OVERLAY_MODAL_HASH)
      this.showModal = true

      const savedOverlay = this.getOverlay(overlayId)

      if (savedOverlay) {
        this.currentOverlay = savedOverlay
      } else {
        this.isLoading = true

        this.fetchOverlay(overlayId)
          .then(overlay => {
            this.currentOverlay = overlay
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    })
  },

  computed: {
    ...mapGetters("overlays", ["getOverlay"])
  },

  methods: {
    isPresent,

    ...mapActions("overlays", ["fetchOverlay"]),

    resetModal() {
      this.currentOverlay = null
      this.$router.removeHash()
    },

    handleClose() {
      this.currentOverlay = null

      // TODO: Figure out more reliable way of queuing actions
      if (EventBus.hasListener(EVENTS.FINISH_SIGN_UP_ACTION)) {
        EventBus.$emit(EVENTS.FINISH_SIGN_UP_ACTION)
        EventBus.$off(EVENTS.POSTING_SIGN_UP_ACTION)
      }
    }
  }
}
</script>
